import { updateSearch } from 'bernie-core';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { UitkLayoutFlex } from 'uitk-react-layout-flex';
import { useStores } from '../../utils/hooks';
import { EGDSSwitch } from '@egds/react-core';
export var ShopWithPointsToggle = function (_a) {
  var _b, _c, _d, _e;
  var data = _a.data;
  var analytics = useStores().analytics;
  var history = useHistory();
  var location = useLocation();
  var label = data.checked ? data.checkedLabel : data.uncheckedLabel;
  var linkName = ((_b = data.checkedAnalytics) === null || _b === void 0 ? void 0 : _b.linkName) || ((_c = data.uncheckedAnalytics) === null || _c === void 0 ? void 0 : _c.linkName);
  var referrerId = ((_d = data.checkedAnalytics) === null || _d === void 0 ? void 0 : _d.referrerId) || ((_e = data.uncheckedAnalytics) === null || _e === void 0 ? void 0 : _e.referrerId);
  var togglePointsApplied = function () {
    analytics.trackEvent(referrerId, linkName, analytics.omnitureData);
    updateSearch({
      history: history,
      location: location,
      newParams: {
        swp: data.checked ? 'off' : 'on'
      },
      newState: {},
      replace: true
    });
  };
  return React.createElement("div", {
    "data-testid": 'shop-with-points'
  }, React.createElement(UitkLayoutFlex, {
    justifyContent: "start"
  }, React.createElement(EGDSSwitch, {
    id: 'shop-with-points',
    checked: data.checked,
    label: label,
    labelClassName: "uitk-type-300",
    onChange: togglePointsApplied
  })));
};